import moment from "moment";
import "moment/locale/pt-br";
import BaseService from '../base.service'
import store from '@/store'
export default class OrderService extends BaseService{

    constructor(){
        super();
    }


    all(page = 1, size = 10 ,filters: any = {}) {
        let filter = ''
        let now = moment()

        if (filters.today) {
            filter += `filter[from]=${now.startOf('day').format("YYYY-MM-D hh:mm:ss")}`
            filter += `&filter[to]=${now.endOf('day').format("YYYY-MM-D hh:mm:ss")}`
        } else {
            filter += Object.keys(filters)
                .filter(k => { return k != 'today' })
                .map(k => { return `filter[${encodeURIComponent(k)}]` + '=' + encodeURIComponent(filters[k])})
                .join('&')

        }

        let url = this.baseURL + `orders?${filter}&page=${page}&size=${size}`;

        return super.get(url);
    }

    orderstatuses() {
        this.conceptId = store.getters['account/activeConcept'].id
        let url = this.baseURL + 'concepts/' + this.conceptId + '/statuses';
        return super.get(url);
    }


    updateorderstatuses(payload: Object = {}, orderstatusID: string | number) {
        this.conceptId = store.getters['account/activeConcept'].id
        let url = this.baseURL + `concepts/` + this.conceptId + `/statuses/${orderstatusID}`

        return super.patch(url, payload);
    }

    validate(params: object = {}) {
        let url = this.baseURL + 'orders/validate'

        return super.post(url, params);
    }

    store(params: {}) {

        let url = this.baseURL + 'orders';

        return super.post(url, params);
    }

    coupon(coupon: string){
        let url = this.baseURL + 'coupons?coupon-code=' + coupon + '&include=promotion' ;
        return super.get(url);
    }

    applycoupon(params: {}){
        let url = this.baseURL + 'orders?include=promotion';

        return super.post(url, params);
    }

    hyperpay(params: {})
    {
        let url = this.baseURL + 'hyperpay/checkout';

        return super.post(url, params);
    }

    hyperpayStatus(params: {})
    {
        let url = this.baseURL + 'hyperpay/get-payment-status';

        return super.post(url, params);
    }

    getOrderStatusSync(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/sync';

        return super.get(url)
    }

    find(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '?include=items';

        return super.get(url)
    }

    statuses(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/statuses?filter[visible]=1';

        return super.get(url)
    }

    feedback(params: {})
    {
        let url = this.baseURL + 'feedback'
        let headers = {
            "Content-Type": "form-data"
        }
        return super.post(url, params, headers)
    }

    postedFeedback(orderId: string)
    {
        let url = this.baseURL + 'orders/'+ orderId +'/ratings/topics'

        return super.get(url)
    }

    topics()
    {
        let url = this.baseURL + '/topics'

        return super.get(url)
    }

    findItems(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/items';

        return super.get(url)
    }

    findResource(orderId: string,itemOrderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/items/' + itemOrderId + '?include=items';

        return super.get(url)
    }

    statusList() {
        let url = this.baseURL + `orders/statuses`
        return super.get(url)
    }

    findStatuses(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/statuses';

        return super.get(url)
    }

    findDriver(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/employees?filter[function]=driver';

        return super.get(url)
    }

    updateStatus(payload: Object = {}, orderId: string) {

        let url = this.baseURL + `orders/${orderId}/statuses`

        return super.post(url, payload)
    }



    updateDate(payload: Object = {}, orderID: string | number) {

        let url = this.baseURL + `orders/${orderID}`

        return super.patch(url, payload);
    }


    cancel(orderId: string, params: any) {

        let url = this.baseURL + 'orders/' + orderId + '/cancellation';

        return super.patch(url, params);
    }

    exportOrder(orderId: string) {
        let url = this.baseURL + `orders/${orderId}/exports`

        return super.post(url, {});
    }

    exportAllOrder() {
        let url = this.baseURL + `orders/exports`

        return super.post(url, {});
    }

    orderPayment(orderId: string) {
        let url = this.baseURL + `orders/${orderId}/payments`

        return super.get(url)
    }

    orderDetails(orderId: string) {
        let url = this.baseURL + `orders/${orderId}?include=items,modifiers,customerAddress,payfortHooks`

        return super.get(url)
    }

    getCustomer(orderId: string) {
        let url = this.baseURL + `customers/${orderId}`

        return super.get(url)
    }

    getCustomerAddresses(customerId: string) {
        let url = this.baseURL + `customers/${customerId}/addresses`

        return super.get(url)
    }
}
